import { render, staticRenderFns } from "./LocationSocial.vue?vue&type=template&id=7c97b624"
import script from "./LocationSocial.vue?vue&type=script&lang=js"
export * from "./LocationSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports